<template>
	<div>
		<div
			style="width: 85%; height: 50vh; margin-left: auto; margin-right: auto; overflow-y: auto; padding: 15px"
			v-if="render"
		>
			<div v-for="variable of variables" :key="variable.id">
				<div class="data-item">
					<div class="label">
						<strong>{{ variable.name }}</strong>
					</div>
					<div class="value">
						<field-type level="-1" :ownerId="school.id" :field="variable" @focus="handleEdit" />
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex"
import FieldType from "./field-type"

export default {
	name: "school-main-form",
	components: {
		FieldType
	},
	props: ["element", "error", "clear"],
	data() {
		return {
			school: { ...this.element },
			edit: false,
			focus: undefined,
			render: false
		}
	},

	async created() {
		await this.doCustomField({ organization_id: this.school.id, level: -1 })
		this.render = true
		this.element.custom_field_values.forEach(element => {
			for (let item of Object.entries(element.custom_field)) {
				if (item.name === "denominazione scuola") this.selected.name.String = item.custom_field_value.value
				if (element.custom_field_id === item.id) {
					element.value = item.custom_field_value.value
				}
			}
		})
		// todo capire cosa fa questa roba sotto che dava errore, questo sopra fa la stessa cosa ma non da errore, MAH. credo niente
		// this.element.custom_field_values.forEach(element => {
		// 	for (let item of this.custom_fields) {
		// 		if (item.name == "denominazione scuola") {this.selected.name.String = item.custom_field_value.value}
		// 		if (element.custom_field_id == item.id) {
		// 			element.value = item.custom_field_value.value
		// 		}
		// 	}
		// })
	},

	computed: {
		...mapGetters({
			variables: "organization/custom_fields"
		})
	},

	methods: {
		...mapActions({
			doCustomField: "organization/doCustomField"
		}),

		validate: function (field, value) {
			this.edit = true
			this.handleEdit()
			if (field == "school_code") {
				if (value.length > 0 && (value.length < 10 || value.length > 10)) {
					this.error.push("school_code")
				} else {
					var i = this.error.indexOf("school_code")
					if (i > -1) this.error.splice(i, 1)
				}
				return
			}
			if (field == "fiscal_code") {
				if (value.length > 0 && (value.length < 11 || value.length > 11)) {
					this.error.push("fiscal_code")
				} else {
					var i = this.error.indexOf("fiscal_code")
					if (i > -1) this.error.splice(i, 1)
				}
				return
			}
		},

		handleEdit: function (value) {
			this.edit = value
			if (value) this.$emit("edit", value)
		}
	},

	watch: {
		clear: function () {
			if (this.clear == undefined) return
			if (this.clear) {
				this.edit = false
				this.load()
			}
		}
	}
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/my-form";
</style>
